
// IT CREATES A COPY OF A VALUE !!!
export function toMomentDate(date:any):MomentDate | null {
    if (!date) return null
    return momentDate(date) as MomentDate
}